<template>
  <div class="warning-forecast-container">
    <div class="warning-title">
      站点：{{stationName}}
    </div>
    <i class="last-modifiedtime-tips">
      <em class="data-picker-container fl">
        <button class="date-picker fl" @click="onPreOrNextPageClick(false)" :disabled="disablePrePageBtn ? 'disabled' : false">前{{TABLE_DAY_COUNT_PER_PAGE}}天</button>
        <button class="date-picker fr" @click="onPreOrNextPageClick(true)" :disabled="disableNextPageBtn ? 'disabled' : false">后{{TABLE_DAY_COUNT_PER_PAGE}}天</button>
      </em>
    </i>
      <div class="warning-main">
        <div class="warning-main-table">
          <el-table
            height="100%"
            v-loading="isLoading"
            :data="tableDataList"
            border
            size="mini"
            :cell-style="changeCellStyle"
            :span-method="mergeCells"
            ref="table">
            <el-table-column
              label="数据来源"
              min-width="110"
              align="center">
              <template slot-scope="scope">
                <div>{{scope.row.weatherStationName}}</div>
                <div style="margin-top:20px;" v-if="!scope.row.isPublicStation && scope.row.distanceMetersFromWeatherStation">距公共气象站点{{scope.row.distanceMetersFromWeatherStation}}Km</div>
              </template>
            </el-table-column>
            <el-table-column
              label="连续120个小时降雨量"
              min-width="80"
              align="center"
              property="sumPrecipitation120h">
            </el-table-column>
            <el-table-column
              v-for="(item,index) in tableHeaderRow"
              :key="index"
              :label="item.label"
              align="center"
              :width="item.width"
              :property="item.property">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="button-box">
        <el-button style="width:10%;" size="mini" @click="goBack">返回</el-button>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { getRequest } from 'utils/http-service'
import { URL_WEATHER_STATION_LIST, URL_WEATHER_STATION_DATA_LIST } from '../../constants/url'
import { MILLISECONDS_PER_DAY } from '../../constants/constants'
import eventBus from '../../utils/EventBus'

export default {
  name: 'jy-weather-station',

  data () {
    return {
      plotList: [],
      airAndSoilDataMap4CropsRplotID: {},
      isLoading: false,
      startTimestamp: '',
      tableDataList: [],
      stationID: '',
      stationName: '',

      /* 以下是表格相关的变量 */
      tableHeaderRow: [], // { label, property }, label是首行表头标签，property是该列数据的key
      TABLE_ROW_TITLE_COLUMN: 0, // 表格的行标题所在的列号，0-plotd
      TABLE_DAILY_DATA_START_COLUMN: 1, // 表格的每日数据开始的列号，0-plotd
      TABLE_DAY_COUNT_PER_PAGE: 12,
      disablePrePageBtn: true,
      disableNextPageBtn: true,
      scrollTop: 0
    }
  },

  created () {
    this.stationID = this.$route.params.stationID
    this.stationName = this.$route.params.stationName
    this.scrollTop = this.$route.params.scrollTop

    this._setColumnProperty()
    this.getPlotListInfo()
  },

  deactivated () {
    this.$destroy()
  },

  methods: {
    goBack () {
      eventBus.$emit('setTableScrollTop', this.scrollTop)
      this.$router.go(-1)
    },

    mergeCells ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 3 !== 0) {
          return [0, 0]
        } else {
          return [3, 1]
        }
      }
    },

    changeCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (rowIndex === 0 && columnIndex === 13) {
          return {'background-color': '#cfd5ea'}
        }
        return {'background-color': '#cfd5ea'}
      } else {
        return {'background-color': '#e9e8f5'}
      }
    },

    onPreOrNextPageClick (gotoNext) {
      if (this.isLoading) {
        return
      }

      let dstPageStartDate = this.startTimestamp +
        this.TABLE_DAY_COUNT_PER_PAGE * MILLISECONDS_PER_DAY * (gotoNext ? 1 : -1)

      this.startTimestamp = dstPageStartDate
      this._setPreOrNextBtnDisableState(dstPageStartDate)
      this._setColumnLabel(dstPageStartDate)
      this._getAndShowPlotAirSoilData(dstPageStartDate)
    },

    // 设置表格每列的property
    _setColumnProperty () {
      let tableHeaderRow = []
      tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN] = { label: '', property: 'rowLabel' }
      for (let i = 0; i < this.TABLE_DAY_COUNT_PER_PAGE; i++) {
        tableHeaderRow[this.TABLE_DAILY_DATA_START_COLUMN + i] =
          { label: '', width: '72', property: 'day' + i + 'Value' }
      }
      this.tableHeaderRow = tableHeaderRow
    },

    getPlotListInfo () {
      getRequest(URL_WEATHER_STATION_LIST, { weatherStationCode: this.stationID, deviceIDs: '' })
        .then(res => {
          let plotListInfo = this._transformPlotInfoData(res.data)
          this.plotList = plotListInfo.plotList
          this.airAndSoilDataMap4CropsRplotID = plotListInfo.airAndSoilDataMap4CropsRplotID

          if (!Array.isArray(this.plotList) || this.plotList.length === 0) {
            this.$message({
              showClose: true,
              message: '当前没有任何站点信息！',
              offset: 300
            })
            console.warn(this.$route.name + ' getPlotListInfo err: 当前没有任何站点信息！')
            return
          }

          this.getDetailData4Plot()
        })
        .catch(err => {
          console.error(this.$route.name + ' getPlotListInfo err: ', err)
        })
    },

    _transformPlotInfoData (resData) {
      let plotListInfo = {}
      let dataList = []
      let airAndSoilDataMap4CropsRplotID = {}

      if (resData.weatherStation) {
        for (let key in resData.weatherStation) {
          let item = resData.weatherStation[key]

          dataList.push({
            weatherStationID: item.weatherStationCode + 'WS',
            weatherStationName: item.weatherStationName,
            sumPrecipitation120h: item.sumPrecipitationRecent120h ? item.sumPrecipitationRecent120h / 100 : item.sumPrecipitationRecent120h,
            distanceMetersFromWeatherStation: 0,
            isPublicStation: true
          })
        }
      }

      if (resData.airIoT) {
        for (let key in resData.airIoT) {
          let item = resData.airIoT[key]

          dataList.push({
            weatherStationID: item.deviceID,
            weatherStationName: 'JY_' + item.serialNumber,
            sumPrecipitation120h: item.sumPrecipitationRecent120h ? item.sumPrecipitationRecent120h / 100 : item.sumPrecipitationRecent120h,
            distanceMetersFromWeatherStation: item.distanceMetersFromWeatherStation ? item.distanceMetersFromWeatherStation / 1000 : '',
            isPublicStation: false
          })
        }
      }

      dataList.forEach((plotItem, index) => {
        plotItem.weatherStationID = plotItem.weatherStationID
        plotItem.weatherStationName = plotItem.weatherStationName
        plotItem.sumPrecipitation120h = plotItem.sumPrecipitation120h
        plotItem.distanceMetersFromWeatherStation = plotItem.distanceMetersFromWeatherStation || ''
        plotItem.isPublicStation = plotItem.isPublicStation

        if (plotItem.sumPrecipitation120h) {
          plotItem.sumPrecipitation120h += 'mm'
        }

        if (plotItem.weatherStationID) {
          airAndSoilDataMap4CropsRplotID[plotItem.weatherStationID] = []
        }
      })

      plotListInfo.plotList = dataList
      plotListInfo.airAndSoilDataMap4CropsRplotID = airAndSoilDataMap4CropsRplotID

      return plotListInfo
    },

    getDetailData4Plot () {
      let startDate = this._getStartTimestampOfDay(new Date().getTime()) -
        (this.TABLE_DAY_COUNT_PER_PAGE - 1) * MILLISECONDS_PER_DAY // -1 to include today. mock: 2020/8/4

      this.startTimestamp = startDate
      this._setColumnLabel(startDate)
      this._getAndShowPlotAirSoilData(startDate)
    },

    // 设置表格每列的标题
    _setColumnLabel (startTimestamp) {
      let tableHeaderRow = this.tableHeaderRow
      tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN].label = '时间'
      tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN].width = 100

      let date = new Date(startTimestamp)
      for (let i = 0; i < this.TABLE_DAY_COUNT_PER_PAGE; i++) {
        tableHeaderRow[this.TABLE_DAILY_DATA_START_COLUMN + i].label =
          date.getMonth() + 1 + '.' + date.getDate()
        date.setDate(date.getDate() + 1)
      }
      this.tableHeaderRow = tableHeaderRow
    },

    _getAndShowPlotAirSoilData (startDate) {
      this.isLoading = true
      let endTimestamp = startDate + (this.TABLE_DAY_COUNT_PER_PAGE) * MILLISECONDS_PER_DAY - 1000

      getRequest(URL_WEATHER_STATION_DATA_LIST, {
        startTimestampIncluded: startDate,
        endTimestampIncluded: endTimestamp,
        weatherStationCode: this.stationID,
        deviceIDs: ''
      }).then(res => {
        this.isLoading = false
        if (!res || !res.data) {
          throw Error('数据异常，服务器错误')
        }

        this._transformAirAndSoilDto2Vo(res.data, startDate)
        this._processTableData()
        this._setPreOrNextBtnDisableState(startDate)
      }).catch(err => {
        this.isLoading = false
        console.error(this.$route.name + ' _getAndShowPlotAirSoilData() err:', err)
      })
    },

    _transformAirAndSoilDto2Vo (dto, startDate) {
      let dtoMap = {}
      let rowTitleColumnProperty = this.tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN].property

      for (let key in this.airAndSoilDataMap4CropsRplotID) {
        this.airAndSoilDataMap4CropsRplotID[key] = []
      }

      if (dto.weatherStation) {
        for (let key in dto.weatherStation) {
          dto.weatherStation[key + 'WS'] = dto.weatherStation[key]
          delete dto.weatherStation[key]
        }
      }

      // if (dto.airIoT) {
      //   for (let id in dto.airIoT) {
      //     let item = dto.airIoT[id]
      //     for (let i = 0; i < item.length; i++) {
      //       item[i].dailySumPrecipitation = item[i].dailySumPrecipitation ? (item[i].dailySumPrecipitation) / Math.pow(10, 2) : item[i].dailySumPrecipitation
      //     }
      //   }
      // }

      dtoMap = Object.assign({}, dto.weatherStation, dto.airIoT)

      try {
        for (let id in dtoMap) {
          let item = dtoMap[id]
          let tableBodyRows = []
          let rowAirTemperature = {}
          let rowAirHumidity = {}
          let rowPrecipitation = {}

          rowAirTemperature[rowTitleColumnProperty] = '空气温度(日平均℃)'
          rowAirHumidity[rowTitleColumnProperty] = '空气湿度(日平均%rh)'
          rowPrecipitation[rowTitleColumnProperty] = '降雨量(日累计mm)'

          for (let i = 0; i < item.length; i++) {
            let dayIndex = this._calculateDiffDayCount(
              item[i].dailyTimestamp, startDate, -1, this.TABLE_DAY_COUNT_PER_PAGE)

            let columnProperty = this.tableHeaderRow[dayIndex + this.TABLE_DAILY_DATA_START_COLUMN].property
            rowAirTemperature[columnProperty] = (item[i].dailyAvgAirTemperature) ? (item[i].dailyAvgAirTemperature) / Math.pow(10, 2) : item[i].dailyAvgAirTemperature
            rowAirHumidity[columnProperty] = (item[i].dailyAvgAirHumidity) ? (item[i].dailyAvgAirHumidity) / Math.pow(10, 2) : item[i].dailyAvgAirHumidity
            rowPrecipitation[columnProperty] = (item[i].dailySumPrecipitation) ? (item[i].dailySumPrecipitation) / Math.pow(10, 2) : item[i].dailySumPrecipitation
          }

          tableBodyRows.push(rowAirTemperature, rowAirHumidity, rowPrecipitation)

          this.airAndSoilDataMap4CropsRplotID[id] = tableBodyRows
        }
      } catch (error) {
        console.error(this.$route.name + ' _transformAirAndSoilDto2Vo() err: ', error)
      }
    },

    _processTableData () {
      let tableDataList = []
      let rowTitleColumnProperty = this.tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN].property

      this.plotList.forEach((item, index) => {
        let arr = this.airAndSoilDataMap4CropsRplotID[item.weatherStationID]

        if (arr.length === 0) {
          arr.push({}, {}, {})
          arr[0][rowTitleColumnProperty] = '空气温度(日平均℃)'
          arr[1][rowTitleColumnProperty] = '空气湿度(日平均%rh)'
          arr[2][rowTitleColumnProperty] = '降雨量(日累计mm)'
        }

        arr[0].weatherStationName = item.weatherStationName
        arr[0].sumPrecipitation120h = item.sumPrecipitation120h
        arr[0].distanceMetersFromWeatherStation = item.distanceMetersFromWeatherStation
        arr[0].isPublicStation = item.isPublicStation

        tableDataList = tableDataList.concat(arr)
      })

      this.tableDataList = tableDataList
    },

    /**
     * 设置 "上一页" 和 "下一页" 按钮是否可点击。
     * 当前页面已有数据时，启用"上一页"按钮。(上一页很难翻到头，暂不考虑左边界)
     * 当前页面已有数据 且 当前页数据的截止时间小于当前日期时，启用"下一页"按钮。
     */
    _setPreOrNextBtnDisableState (startDate) {
      this.disablePrePageBtn = true
      this.disableNextPageBtn = true

      if (this.plotList.length > 0) {
        this.disablePrePageBtn = false

        if (startDate + this.TABLE_DAY_COUNT_PER_PAGE * MILLISECONDS_PER_DAY <
            this._getStartTimestampOfDay(new Date().getTime())) {
          this.disableNextPageBtn = false
        }
      }
    },

    // 获取给定时间戳代表的那一天的初始时刻的时间戳
    _getStartTimestampOfDay (timestamp) {
      let date = new Date()
      date.setTime(timestamp)
      date.setMilliseconds(0)
      date.setSeconds(0)
      date.setMinutes(0)
      date.setHours(0)
      return date.getTime()
    },

    // 计算给定的timestamp距离startTimestamp的天数，向下取整。
    // 如果参数异常，或者相距离天数 <= minLimit 或 >= maxLimit，抛出异常
    _calculateDiffDayCount (timestamp, startTimestamp, minLimit, maxLimit) {
      if (isNaN(timestamp) || isNaN(startTimestamp) ||
          isNaN(minLimit) || isNaN(maxLimit)) {
        throw Error('_calculateDiffDayCount() invalid params')
      }
      let dayCount = Math.floor((timestamp - startTimestamp) / MILLISECONDS_PER_DAY) // 0-plotd
      if (dayCount <= minLimit || dayCount >= maxLimit) {
        throw Error('_calculateDiffDayCount() diff days' + dayCount +
          ' out of range [' + minLimit + ', ' + maxLimit + ']')
      }
      return dayCount
    }
  }
}
</script>

<style lang="less" scoped>
.warning-forecast-container {
  width:100%;
  height:100%;
  display: flex;
  flex-direction: column;
  .warning-title {
    padding-top: 25px;
    padding-left: 45px;
    padding-bottom: 20px;
    font-weight: bold;
    width: 100%;
    border-bottom: 1px solid #ccc;
    .tips {
      padding: 0 40px 10px;
      border-bottom: 1px solid #ccc;
      span {
        color: rgb(26, 15, 190);
      }
    }
    .search-params-form {
      width: 100%;
      height: 100%;
      .no-label /deep/ .el-form-item__label {
        width: 0!important;
      }
      .large-label /deep/ .el-form-item__label {
        width: 140px!important;
      }
      .search-button {
        display: inline-block;
        margin-right: 70px;
      }
    }
  }
  & > i {
    display: block;
    height: 30px;
    padding: 0 48px;
    margin: 6px 0;
    .warning-tips {
      display: flex;
      justify-content: space-between;
      width: 420px;
      padding-top: 6px;
      font-size: 12px;
      div {
        display: flex;
        align-items: center;
      }
      .quick-operation {
        cursor: pointer;
      }
      .warning-box {
        display: inline-block;
        margin: 0 7px 0;
        width: 22px;
        height: 16px;
        border-radius: 4px;
      }
    }
    &.last-modifiedtime-tips {
      display:block;
      width:100%;
      height:22px;
      font-size:0;
    }
    .data-picker-container {
      display: block;
      width: 140px;
      padding-top: 5px;
      height: 100%;
      button {
        display: block;
        height: 100%;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
  .warning-plot-location {
    width: 100%;
    height: 30px;
    padding: 0 45px;
    .location-title {
      display: flex;
      width: 100%;
      height: 30px;
      background-color: rgb(13, 99, 13);
      & > div {
        color: #fff;
        width: 202px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #eee;
        &.plot-name {
          flex: 1;
        }
        &.plot-location {
          width: 651px;
        }
        &.plot-longitude {
          width: 216px;
        }
      }
    }
  }
  .warning-main {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-height: 0;
    padding: 0 45px;
    .warning-main-table {
      width: 100%;
      height: 100%;
    }
  }
  .warning-main-confirm{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    button {
      width: 110px;
      height: 38px;
      outline: none;
      padding: 0;
      border: 1px solid #666;
      border-radius: 5px;
      cursor: pointer;
      margin-bottom: 5px;
    }
    button.warning-forecast-achieve {
      margin-bottom: 0;
    }
  }
  .el-table td div .el-radio-group {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0 26px;
    .el-radio-button {
      margin-bottom: 10px;
      /deep/ .el-radio-button__inner {
        display: block;
        border-radius: 4px;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    height: 30px;
    margin: 10px 65px;
  }
  .button-box {
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/warning-forecast/jy-weather-station.vue